import React from 'react'
import ReactMarkdown, { type Components } from 'react-markdown'
import styled from 'styled-components'

const MarkdownRoot = styled.div`
  margin: 0;
  color: var(--foreground);
  font-size: inherit;
  font-weight: 400;
  line-height: inherit;
  overflow-wrap: anywhere;

  p {
    margin: 0 0 0.5em;
    font-weight: 400;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    margin: 0.25em 0;
    padding-left: 1.25em;
  }

  li {
    margin: 0.1em 0;
    font-weight: 400;
  }

  em {
    font-style: italic;
  }

  code {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 0.9em;
  }
`

const Bold = styled.strong`
  color: var(--foreground);
  font-weight: 700 !important;
`

const markdownComponents: Components = {
  strong: ({ children }) => <Bold>{children}</Bold>,
  b: ({ children }) => <Bold>{children}</Bold>,
}

export function AgenticMarkdown({
  children,
}: {
  children: string
}): React.ReactElement {
  return (
    <MarkdownRoot>
      <ReactMarkdown components={markdownComponents}>{children}</ReactMarkdown>
    </MarkdownRoot>
  )
}
